import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField as MaterialTextField } from '@material-ui/core';

export const TextField = withStyles({
  root:{
    minHeight: 19
  }
})(MaterialTextField);

export default makeStyles(theme => ({
  inputContainer: {
    position: 'relative',
    padding: 8,
    paddingLeft: ({WIDE_MODE}) => WIDE_MODE ? 20 : 8,
    display: 'flex',
    flexDirection: 'column',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.09)',
    minHeight: 55, //only here because of IE11
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0
    }
  },
  userInput: {
    fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
    padding: 0,
    margin: 0,
    width: '100%',
    '&.fileUploaded': {
      '& .MuiOutlinedInput-root': {
        fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
        '& textarea': {
          border: 0,
          boxShadow: 'none',
          color: 'currentColor',
          margin: 0,
          fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
          "&::placeholder": {
            color: 'red',
            opacity: 1
          }
        },
      }
    },
    '&.MuiOutlinedInput-multiline': {
      '& .MuiOutlinedInput-marginDense': {
        padding: 0
      }
    },
    '& .MuiOutlinedInput-root': {
      fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
      margin: 0,
      '& textarea': {
        border: 0,
        boxShadow: 'none',
        color: 'currentColor',
        margin: 0,
        fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
        "&::placeholder": {
          color: 'black',
          opacity: 1
        },
        fontSize: 14,
        lineHeight: 'normal',
        fontStyle: 'normal',
        fontVariantLigatures: 'normal',
        fontVariantCaps: 'normal',
        fontVariantNumeric: 'normal',
        fontVariantEastAsian: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        height: 19,
        minHeight: 19
      },
      '& fieldset': {
        borderColor: 'transparent',
      },
      '&:hover fieldset': {
        borderColor: 'transparent',
      },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent',
      },
    },
  },
  sendIcon: {
    boxSizing: 'content-box',
    fill: ({ SEND_ICON_COLOR }) => SEND_ICON_COLOR,
    padding: 5,
    margin: '6px 12px 0px 12px',
    fontSize: 20,
    transition: '0.3s transform, 0.4s opacity',
    cursor: 'pointer',
    opacity: 1,
    '&:active': {
      transform: 'scale(1.4) rotate(15deg)'
    },
    '&.hideSendIcon': {
      opacity: 0,
      transform: 'translateX(10px)'
    }
  },
  menuIcon: {
    width: 24,
    height: 24,
    boxSizing: 'content-box',
    fill: ({ SEND_ICON_COLOR }) => SEND_ICON_COLOR,
    padding: '8px 15px',
    borderRadius: 10,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e6e6e6'
    },
    [theme.breakpoints.up('md')]: {
      display: ({WIDE_MODE, SIDEBAR}) => WIDE_MODE ? (SIDEBAR.enabled ? 'none' : 'auto') : 'auto'
    }
  },
  fileUploadBtn: {
    padding: '9px 4px',
    '& svg': {
       fill: ({ SEND_ICON_COLOR }) => SEND_ICON_COLOR,
       width: 24,
       height: 24
    }
  },
  fileLabelDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: 42,
    width: '100%',
    '& h4': {
      fontWeight: 300,
      margin: '0 10px',
      maxWidth: 175,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [theme.breakpoints.down('sm')]: {
        maxWidth: 155
      }
    },
    '& img': {
      height: 30
    },
    [theme.breakpoints.down('sm')]: {
      '& .preText': {
        display: 'none'
      }
    }
  },
  watermark: {
    textAlign: 'center',
    color: '#8c8c8c',
    padding: 4,
    fontSize: 11,
    display: ({WIDE_MODE}) => WIDE_MODE ? 'none' : 'initial',
    [theme.breakpoints.only('xs')]: {
      display: 'initial !important'
    },
    '& a': {
      color: ({GLOBAL_COLOR}) => GLOBAL_COLOR
    }
  }
}));
